/**
 * Single source of truth for Terms / Privacy / Disclosures freshness.
 * Bump this ISO date whenever counsel approves a wording change in
 * `legal_terms.sections`, `legal_privacy.sections` or `legal_disclosures.sections`
 * (or any other clause). All three legal modals + the footer auto-update.
 */
export const LEGAL_UPDATED_AT = "2026-02-26";
